import { createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c2910c6a")

_pushScopeId("data-v-c2910c6a")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("スタッフ情報の一括編集")
const _hoisted_2 = { class: "flex flex-col gap-8 w-full max-w-2xl mx-auto" }
const _hoisted_3 = { class: "flex items-start gap-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "flex items-center justify-center w-7 h-7 rounded-full bg-primary-500 text-white font-bold text-sm shrink-0" }, " 1 ", -1)
const _hoisted_5 = { class: "flex-1" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "text-lg font-medium mb-3" }, " 現在のスタッフ情報をエクスポート ", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "全スタッフをCSVでダウンロード", -1)
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-start gap-4\" data-v-c2910c6a><div class=\"flex items-center justify-center w-7 h-7 rounded-full bg-primary-500 text-white font-bold text-sm shrink-0\" data-v-c2910c6a> 2 </div><div class=\"flex-1\" data-v-c2910c6a><p class=\"text-lg font-medium mb-2\" data-v-c2910c6a> ダウンロードしたCSVを編集 </p><p class=\"text-gray-500\" data-v-c2910c6a> 必要な項目を変更してください。 </p></div></div>", 1)
const _hoisted_9 = { class: "flex items-start gap-4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "flex items-center justify-center w-7 h-7 rounded-full bg-primary-500 text-white font-bold text-sm shrink-0" }, " 3 ", -1)
const _hoisted_11 = { class: "flex-1" }
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "text-lg font-medium mb-3" }, " 編集したCSVを取り込み ", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" ファイルを選択して取り込み ")
const _hoisted_14 = { class: "bg-amber-50 border border-amber-200 rounded-lg p-4 text-sm" }
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "font-medium text-amber-800 mb-2" }, "注意事項", -1)
const _hoisted_16 = { class: "list-disc list-inside text-amber-700 space-y-1" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createVNode("li", null, " メールアドレスの変更は、対象スタッフの次回ログインに影響する場合があります。 ", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("li", null, " 「パスワードログインを無効にする」を「する」にする場合は、GoogleアカウントまたはMicrosoftアカウントが必要です。 ", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("li", null, " 「パスワードログインを無効にする」列が無いCSV、および空欄のセルは、この設定を変えません。 ", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("li", null, " 教室名にカンマが含まれる場合は、ダブルクォーテーションで囲んでください。例: 保健,体育 → \"保健,体育\" ", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "text-base text-gray-500 mt-0" }, [
  /*#__PURE__*/_createTextVNode(" 詳細は"),
  /*#__PURE__*/_createVNode("a", {
    href: "https://mingaku.notion.site/61eef296e77483bba7f081a64a798ceb",
    target: "_blank",
    class: "text-sky underline cursor-pointer"
  }, "ガイド"),
  /*#__PURE__*/_createTextVNode("をご覧ください。 ")
], -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("div", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_base_modal = _resolveComponent("m-base-modal")

  return (_openBlock(), _createBlock(_component_m_base_modal, { onClose: _ctx.close }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    body: _withId(() => [
      _createVNode("section", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_m_button, {
              color: "primary-500",
              "hover-color": "primary-600",
              outline: "",
              onClick: _ctx.exportStaffs
            }, {
              default: _withId(() => [
                _createVNode(_component_m_icon, {
                  type: "plus",
                  width: "4",
                  class: "mr-2"
                }),
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _hoisted_8,
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_m_button, {
              color: "primary-500",
              "hover-color": "primary-600",
              onClick: _ctx.startUpdating
            }, {
              default: _withId(() => [
                _hoisted_13
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode("ul", _hoisted_16, [
            _createVNode("li", null, _toDisplayString(_ctx.ownerLabel) + "・" + _toDisplayString(_ctx.adminLabel) + "は、教室の指定に関わらず自動的に全ての教室に所属します。そのため、CSVの教室名は空欄で出力されます。 ", 1),
            (_ctx.isOwner)
              ? (_openBlock(), _createBlock("li", _hoisted_17, " 管理者に一括編集の権限を付与すると、メールアドレス等の重要な情報を編集できるようになります。権限の付与は慎重にご検討ください。 "))
              : _createCommentVNode("", true),
            _hoisted_18,
            _hoisted_19,
            _hoisted_20,
            _hoisted_21
          ])
        ]),
        _hoisted_22
      ])
    ]),
    footer: _withId(() => [
      _hoisted_23
    ]),
    _: 1
  }, 8, ["onClose"]))
})